function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { VCheckbox } from 'vuetify/lib';
import FormMixin from '../form.mixin';

var CheckboxGroup = /*#__PURE__*/function () {
  function CheckboxGroup() {
    _classCallCheck(this, CheckboxGroup);
  }

  _createClass(CheckboxGroup, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-checkbox-group', {
        template: "\n        <div class=\"checkbox-group custom-group\" :class=\"bind.class\">\n          <v-checkbox\n            v-for=\"(item, index) in items\"\n            v-model=\"checkboxValues\"\n            :key=\"item.value\"\n            :value=\"item.value\"\n            :label=\"item.label\"\n            :rules=\"[() => customRules.oneValueSelected(checkboxValues)]\"\n            :hide-details=\"true\"\n            :ripple=\"false\"\n            @update:error=\"updateError\"\n            @change=\"$emit('input', checkboxValues)\"\n          >\n        </v-checkbox>\n        <div v-if=\"error\" class=\"v-messages theme--light error--text\">\n          <span>{{ error }}</span>\n        </div>\n      </div>\n      ",
        mixins: [FormMixin],
        components: {
          VCheckbox: VCheckbox
        },
        props: {
          items: {
            type: Array,
            "default": function _default() {
              return [];
            }
          }
        },
        data: function data() {
          var _this = this;

          return {
            checkboxValues: [],
            customRules: {
              oneValueSelected: function oneValueSelected(selected) {
                if (!_this.bind.rules.length || _this.bind.rules[0].name !== 'required') {
                  return true;
                }

                return selected.length > 0 || _this.$root.labels.ruleRequired;
              }
            },
            error: null
          };
        },
        methods: {
          updateError: function updateError(error) {
            if (error) {
              this.error = this.$root.labels.ruleRequired;
              return;
            }

            this.error = null;
          }
        }
      });
    }
  }]);

  return CheckboxGroup;
}();

export default CheckboxGroup;